(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sweaty-yeti-configurator"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sweaty-yeti-configurator]').forEach((configurator) => {
    const total = configurator.querySelector('[data-config-total]');
    const totalInput = configurator.querySelector('[data-config-total-input]');
    const summary = configurator.querySelector('[data-config-summary]');
    const properties = configurator.querySelector('[data-config-properties]');
    const cartNote = configurator.querySelector('[data-config-cart-note]');
    const basePrice = Number(configurator.dataset.basePrice || 0);
    const currency = configurator.dataset.currency || 'USD';
    const formatCurrency = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amount / 100);

    const updateConfiguration = () => {
      const selected = Array.from(configurator.querySelectorAll('[data-config-input]:checked'));
      const additions = selected.reduce((sum, input) => sum + Number(input.dataset.cents || 0), 0);
      const estimatedTotal = formatCurrency(basePrice + additions);
      const selections = selected.map((input) => `${input.dataset.group}: ${input.dataset.label}`);

      total.textContent = estimatedTotal;
      totalInput.value = `${configurator.dataset.estimatedLabel}: ${estimatedTotal}`;

      // Carry the configuration onto the order line, and say plainly that the
      // cart is charging the base build only.
      if (properties) {
        properties.innerHTML = '';
        selected.forEach((input) => {
          const cents = Number(input.dataset.cents || 0);
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `properties[${input.dataset.group}]`;
          field.value = cents > 0
            ? `${input.dataset.label} (+${formatCurrency(cents)})`
            : input.dataset.label;
          properties.appendChild(field);
        });
      }

      if (cartNote) {
        cartNote.textContent = additions > 0
          ? `Checkout charges the base build at ${formatCurrency(basePrice)}. The ${formatCurrency(additions)} of upgrades you chose is not charged here; we confirm and invoice it with your quote.`
          : `Checkout charges the base build at ${formatCurrency(basePrice)}. Upgrades you choose above are quoted separately.`;
      }
      summary.value = [
        configurator.dataset.summaryIntro,
        '',
        `${configurator.dataset.estimatedLabel}: ${estimatedTotal}`,
        '',
        ...selections,
      ].join('\n');
    };

    configurator.addEventListener('change', updateConfiguration);
    updateConfiguration();
  });
  } catch(e) { console.error(e); }
})();

})();
